import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getCurrencyGlobalLimits } from 'services/PaymentLimitsService'

export const useGetCurrencyGlobalLimits = (currency?: string, isEnabled = true) => {
  return useQuery({
    queryKey: reactQueryKeys.currencyGlobalLimits(currency ?? ''),
    queryFn: () => getCurrencyGlobalLimits(currency as string),
    enabled: isEnabled && !!currency,
  })
}
